import React from 'react';
import { useRefreshGoogleAuth } from '../../services/react-query/integrations/google_calendar/useRefreshGoogleAuth';
import { Integration } from '../../types/Integration';
import CalendarIntegrationCard from './CalendarIntegrationCard';

interface GoogleCalendarIntegrationProps {
  integration?: Integration;
  isLoading?: boolean;
}

export default function GoogleCalendarIntegration({ integration, isLoading = false }: GoogleCalendarIntegrationProps) {
  const { mutate: refreshGoogleAuth } = useRefreshGoogleAuth();

  const isSynced = !!integration?.enabled;

  return (
    <CalendarIntegrationCard
      label="Google Calendar"
      logoSrc="/svg/google_calendar.svg"
      isSynced={isSynced}
      onConnect={refreshGoogleAuth}
      isLoading={isLoading}
    />
  );
}
